import { Item } from '../components/Item';
import * as Styled from '../index.css';

export const SectionBenefits = (): JSX.Element => (
  <Styled.Container>
    <Styled.Header>
      <Styled.Heading>
        Die Vorteile der Kfz-Versicherung im Überblick
      </Styled.Heading>

      <Styled.Text>
        Ob Haftpflicht- oder Kaskoversicherung: passgenauer Schutz für alle
        Fahrzeugmarken.
      </Styled.Text>
    </Styled.Header>

    <Styled.Content>
      <Item
        iconPath="icon-insurance.svg"
        iconAltText="icon representing vehicle insurance"
        heading="Maßgeschneiderter Versicherungsschutz"
      >
        <Styled.Text>
          Stellen Sie sich Ihre Kfz-Versicherung aus unseren Produktlinien nach
          Ihrem persönlichen Bedarf zusammen.
        </Styled.Text>
      </Item>

      <Item
        iconPath="inspection.svg"
        iconAltText="icon representing a vehicle inspection"
        heading="Reparatur in der Fachwerkstatt"
      >
        <Styled.Text>
          Im Schadenfall wird Ihr Fahrzeug fachgerecht repariert – und das mit
          Originalteilen des Herstellers oder gleichwertigen Ersatzteilen.
        </Styled.Text>
      </Item>

      <Item
        iconPath="home/icon-dealer.svg"
        iconAltText="icon representing a dealer"
        heading="Alles aus einer Hand"
      >
        <Styled.Text>
          Bei Fragen oder im Schadenfall: Wir als ihr profesioneller
          Ansprechpartner unterstützt Sie bei der Schadenabwicklung.
        </Styled.Text>
      </Item>

      <Item
        iconPath="icon-car-new.svg"
        iconAltText="icon representing a new vehicle"
        heading="Besondere Leistungen für Elektro-/Hybridfahrzeuge"
      >
        <Styled.Text>
          Beispielsweise die Allgefahrendeckung für Ihren Akku, Diebstahl des
          Ladekabels und Überspannungsschäden an elektrischen Fahrzeugbauteilen.
        </Styled.Text>
      </Item>
    </Styled.Content>
  </Styled.Container>
);
